import { combineReducers } from 'redux';
import usCorpOrPartnershipReducer from './USCorpOrPartnership/slice';
import nonUsCorpOfPartnershipReducer from './NonUSCorpofPartnership/slice';
import usTrustReducer from './USTrust/slice';
import nonUsTrustReducer from './NonUSTrust/slice';
import generalReducer from './General/slice';

export default combineReducers({
  general: generalReducer,
  usCorpOrPartnership: usCorpOrPartnershipReducer,
  nonUsCorpOfPartnership: nonUsCorpOfPartnershipReducer,
  usTrust: usTrustReducer,
  nonUsTrust: nonUsTrustReducer,
});
